import React, { Component } from 'react'
import { Heading } from '@myxplor/ui'
import LocalAsyncStore from '../../local-async-store'
import { GovMessage } from './views'
import { pluralise } from '../../text-transformations'
import { ShowHide } from '../record-display'

export class GovMessages extends Component {
  constructor(props) {
    super(props)
    this.state = props.messages || {}
    this.removeMessage = this.removeMessage.bind(this)
  }

  removeMessage(message_index) {
    let messages = [...this.state.data]
    messages.splice(message_index, 1)

    this.setState({
      data: messages,
    })
  }

  render() {
    if (!this.props.messages) return null
    if (this.props.messages.data.length === 0) return null

    const { data } = this.props.messages
    const apiEndPointBase = apiEndPoint(this.props)

    return (
      <div className="govMessages--wrapper">
        <Heading small compact>
          {pluralise(data.length, 'Government Message')}
        </Heading>
        <ShowHide label="messages">
          <ol className="govMessages--list">
            {data.map((message, i) => (
              <GovMessage
                key={i}
                message={message}
                afterDelete={() => this.removeMessage(i)}
                apiEndPoint={`${apiEndPointBase}/${message.gov_id}`}
              />
            ))}
          </ol>
        </ShowHide>
      </div>
    )
  }
}

const apiEndPoint = ({ record_type, record_id }) => `/api/${record_type}/${record_id}/messages`

export default LocalAsyncStore('messages', GovMessages, apiEndPoint)



// WEBPACK FOOTER //
// ./src/ui/gov-messages/container.jsx